/**
 * Estados terminais canônicos (ADR-054 Fatia F) + o legado `closed`.
 *
 * Domicílio único. Antes desta promoção a lista vivia copiada em QUATRO
 * lugares independentes — `apps/lume-atendimento/src/features/conversations/
 * format.ts`, `apps/lume-atendimento-mobile/src/features/conversation/
 * format.ts`, `apps/lume-atendimento-mobile/src/features/conversation/
 * Composer.tsx` e `packages/shared/src/worklist/worklist-adapter.ts`. As
 * quatro concordavam nos valores, e o docblock do Composer mobile já
 * declarava a régua da promoção: «se um 3º consumidor aparecer, promover».
 *
 * `closed` é legado e fica: o enum do Prisma ainda o aceita, e conversa
 * gravada antes da Fatia F carrega esse valor.
 */
export const TERMINAL_CONVERSATION_STATUSES = [
    'closed',
    'resolved',
    'closed-unresolved',
    'archived',
];
/** A conversa está encerrada — não aceita mensagem nem atribuição. */
export function isTerminalConversationStatus(status) {
    return TERMINAL_CONVERSATION_STATUSES.includes(status);
}
/**
 * O banner de condução da IA («a IA está segurando a fila… clique para
 * assumir») vale nesta conversa?
 *
 * Duas pernas, ambas necessárias. `operationMode` é um dado GRAVADO na
 * conversa — ele não se apaga quando ela fecha —, então o modo sozinho diz
 * apenas o que a IA estava fazendo, não se ainda há o que fazer. O banner
 * OFERECE AÇÃO, e numa conversa encerrada não há fila a segurar: desde
 * 13/Ago/2026 o engine recusa o `claim` nos 4 terminais com 409
 * (`code: 'conversation_closed'`). Sem a segunda perna a tela oferece o que o
 * servidor recusa.
 *
 * O tipo de `operationMode` é `string | undefined` de propósito: os dois apps
 * o leem de um objeto opcional do wire, e estreitar aqui só empurraria o
 * `??`/cast para os chamadores.
 */
export function conducaoIaVisivel(operationMode, status) {
    return operationMode === 'H_c' && !isTerminalConversationStatus(status);
}
//# sourceMappingURL=terminal-status.js.map